export default "__VITE_ASSET__Qh$gFapm__"